import NoAnimationModule from './NoAnimationModule';

export default NoAnimationModule;
